module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "selection"
  }, [_vm._v("\n    " + _vm._s(_vm.count(_vm.selection)) + " " + _vm._s(_vm.$t('text.of')) + " " + _vm._s(_vm.count(_vm.collection)) + " | " + _vm._s(_vm.$t('text.selection.select')) + "\n    "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.selectAll.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('text.selection.all')))]), _vm._v("\n    " + _vm._s(_vm.$t('text.or')) + "\n    "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.selectNone.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('text.selection.none')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cdda43d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Selection.vue
// module id = 569
// module chunks = 225